/**
 * Print version number in HTML.
 */
export const printVersion = () => {
  const version = document.getElementById('version')
  version.textContent = VERSION
}
